export const DEFAULT_PROVINCE = "Daerah Khusus Ibukota Jakarta";

export const fetchProvinces = async ({ signal } = {}) => {
  const res = await fetch(
    "https://ibnux.github.io/data-indonesia/provinsi.json",
    { signal },
  );
  if (!res.ok) throw new Error("Gagal memuat data provinsi");
  const provinces = await res.json();
  if (
    !Array.isArray(provinces) ||
    !provinces.length ||
    provinces.some((province) =>
      !province || typeof province.id !== "string" ||
      typeof province.nama !== "string" || !province.nama.trim()
    )
  ) throw new Error("Data provinsi tidak valid");
  return provinces;
};
